import { useAccounts } from './useAccounts';
import { useAccountsFilter } from './useAccountsQuery';

export const useAccountsWithFilters = () => {
    const { filters } = useAccountsFilter();
    const accounts = useAccounts(filters);

    return accounts;
};